import React from 'react';
import { Page } from '../Common/Components/Page';
import { RoleManagementContent } from './Components/RoleManagementContent';

export const RoleManagement = (): React.JSX.Element => (
  <Page title="Roles" accessKey={'roles'} isSearchable={false}>
    <RoleManagementContent />
  </Page>
);
